import React from 'react';
import StockCaseDisplay from './StockCaseDisplay';
import { translate } from '../../Services/translation';
import onHandCheckLeadTimeLanguage from '../../Services/onHandCheckLeadTimeLanguage';

const StockDetails = (props) => {
  const { quantity, nextIncomingQuantity, leadTimeVendor } = props.stockArticle;

  if (quantity <= 0 && nextIncomingQuantity <= 0) {
    if (leadTimeVendor > 0) {
      return (
        <div>
          {onHandCheckLeadTimeLanguage('configstock.leadtime.loginuser', leadTimeVendor, 'configstock.leadtimedays')}
        </div>
      );
    } else {
      return <div>{translate('configstock.contactbe')}</div>;
    }
  }

  return <StockCaseDisplay {...props} />;
};

export default StockDetails;
